import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import FanxoLogo from "../../Assets/Images/FanxoLight.svg";
import SignOutConfirmationModal from "../SignOutConfirmationModal";
import { logout } from "../../Redux/slices/authSlice";
import { AppDispatch } from "../../Redux/store";
import { clearLocalCreatorPushSubscription } from "../../Utils/pushNotificationLocal";
import * as S from "./styled";

const SUPPORT_EMAIL = "business@fanxo.club";

const RestrictedAccountScreen: React.FC = () => {
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const [showConfirm, setShowConfirm] = useState(false);

  const contactSupport = () => {
    window.location.href = `mailto:${SUPPORT_EMAIL}?subject=Fanxo Account Support`;
  };

  const useDifferentAccount = async () => {
    setShowConfirm(false);
    await clearLocalCreatorPushSubscription();
    dispatch(logout());
    navigate("/signup", { replace: true });
  };

  return (
    <S.Screen>
      <S.Content>
        <S.Logo src={FanxoLogo} alt="Fanxo" />
        <S.Title>Account restricted</S.Title>
        <S.Body>
          Your account has been restricted or deleted.
          <br />
          <br />
          Please contact support at
          <br />
          <S.Email href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</S.Email>.
        </S.Body>
        <S.PrimaryButton type="button" onClick={contactSupport}>
          Contact Support
        </S.PrimaryButton>
        <S.SecondaryButton type="button" onClick={() => setShowConfirm(true)}>
          Use a different account
        </S.SecondaryButton>
      </S.Content>
      <SignOutConfirmationModal
        show={showConfirm}
        onStay={() => setShowConfirm(false)}
        onConfirm={useDifferentAccount}
        title="Use a different account?"
        body="This will sign you out of this account and take you to sign up."
        stayLabel="Cancel"
        confirmLabel="Continue"
      />
    </S.Screen>
  );
};

export default RestrictedAccountScreen;
